import { createFileRoute } from "@tanstack/react-router";
import { AuthLayout } from "@/components/auth/auth-layout";
import { Loader } from "@/components/Loader";
import { useAuth } from "@/components/providers/auth";
import { redirectIfModuleDisabled } from "@/lib/module-guards";

export const Route = createFileRoute("/auth")({
	beforeLoad: () => redirectIfModuleDisabled("auth", "/"),
	component: Auth,
});

export function Auth() {
	const auth = useAuth();

	if (auth.isInitialLoading) {
		return <Loader />;
	}

	return <AuthLayout />;
}
